import { Exclude, Expose } from "class-transformer";

@Exclude()
class UpdateStaffCartDto {
    @Expose()
    readonly staff_id: number;
}

export default UpdateStaffCartDto;
